import Env from 'env-service'
// Firebase App (the core Firebase SDK) is always required and must be listed first
import firebase from "firebase/app"
// Add the Firebase products that you want to use
import "firebase/auth"

if (Env.IS_PRODUCTION_CONNECTION) {
  firebase.initializeApp({
    apiKey: 'AIzaSyDUbrRel-AuAnIKZG4BltoXt06iQC2Coxk',
    authDomain: 'adacado-go.firebaseapp.com',
    databaseURL: 'https://adacado-go.firebaseio.com',
    projectId: 'adacado-go',
    storageBucket: 'adacado-go.appspot.com',
    messagingSenderId: '707577836392'
  })
} else {
  // This configuration is the same as above.
  // Stick with one firebase for now... setup of adacado-qa project in firebase/google apis
  // to onerous, we'll do this later along with filtering out email domains.
  firebase.initializeApp({
    apiKey: 'AIzaSyDUbrRel-AuAnIKZG4BltoXt06iQC2Coxk',
    authDomain: 'adacado-go.firebaseapp.com',
    databaseURL: 'https://adacado-go.firebaseio.com',
    projectId: 'adacado-go',
    storageBucket: 'adacado-go.appspot.com',
    messagingSenderId: '707577836392'
  })
}

export default firebase
